import { apiRequest } from "@nusrif/utils";
import { ApiResponse, DeliveryEstimateResponse } from "@nusrif/types";

/*
 * Fetches the delivery estimate for a given destination pin.
 * @param {string} destinationPin - The pin code of the delivery destination.
 * @returns {Promise<ApiResponse<DeliveryEstimateResponse>>} - A promise that resolves to the delivery estimate response.
 */

export async function getDeliveryEstimate(destinationPin: string): Promise<ApiResponse<DeliveryEstimateResponse>> {
    return apiRequest<ApiResponse<DeliveryEstimateResponse>>(`/delivery/estimate/${destinationPin}`, {
        method: 'GET'
    });
}